import { JSBI, Percent } from 'sdk'
import { WFTM, DAI, USDT, DMD } from './tokens'

export const ROUTER_ADDRESS = '0xF491e7B69E4244ad4002BC14e878a34207E38c29'

// used to construct intermediary pairs for trading
export const BASES_TO_CHECK_TRADES_AGAINST = {
  250: [DMD[250], USDT],
  4002: [DMD[4002]],
}

/**
 * Addittional bases for specific tokens
 * @example { [WBTC.address]: [renBTC], [renBTC.address]: [WBTC] }
 */
export const ADDITIONAL_BASES = {
  250: {},
}

/**
 * Some tokens can only be swapped via certain pairs, so we override the list of bases that are considered for these
 * tokens.
 * @example [AMPL.address]: [DAI, WFTM[250]]
 */
export const CUSTOM_BASES = {
  250: {},
}

// used to construct the list of all pairs we consider by default in the frontend
export const BASES_TO_TRACK_LIQUIDITY_FOR = {
  250: [WFTM[250], DAI, USDT],
  4002: [DMD[4002]],
}

// used for display in the default list when adding liquidity
export const SUGGESTED_BASES = {
  250: [DMD[250]],
  4002: [WFTM[4002], DMD[4002]],
}

export const PINNED_PAIRS = {
  250: [
    [DMD[250], WFTM[250]],
    [DAI, USDT],
  ],
}

// default allowed slippage, in bips
export const INITIAL_ALLOWED_SLIPPAGE = 50
// 20 minutes, denominated in seconds
export const DEFAULT_DEADLINE_FROM_NOW = 60 * 20

// one basis point
export const ONE_BIPS = new Percent(JSBI.BigInt(1), JSBI.BigInt(10000))
export const BIPS_BASE = JSBI.BigInt(10000)
// used for warning states
export const ALLOWED_PRICE_IMPACT_LOW: Percent = new Percent(JSBI.BigInt(100), BIPS_BASE) // 1%
export const ALLOWED_PRICE_IMPACT_MEDIUM: Percent = new Percent(JSBI.BigInt(300), BIPS_BASE) // 3%
export const ALLOWED_PRICE_IMPACT_HIGH: Percent = new Percent(JSBI.BigInt(500), BIPS_BASE) // 5%
// if the price slippage exceeds this number, force the user to type 'confirm' to execute
export const PRICE_IMPACT_WITHOUT_FEE_CONFIRM_MIN: Percent = new Percent(JSBI.BigInt(1000), BIPS_BASE) // 10%
// for non expert mode disable swaps above this
export const BLOCKED_PRICE_IMPACT_NON_EXPERT: Percent = new Percent(JSBI.BigInt(1500), BIPS_BASE) // 15%

// used to ensure the user doesn't send so much FTM so they end up with <.01
export const MIN_FTM: JSBI = JSBI.exponentiate(JSBI.BigInt(10), JSBI.BigInt(16)) // .01 FTM
export const BETTER_TRADE_LESS_HOPS_THRESHOLD = new Percent(JSBI.BigInt(50), JSBI.BigInt(10000))

export const ZERO_PERCENT = new Percent('0')
export const ONE_HUNDRED_PERCENT = new Percent('1')

export { default as farmsConfig } from './farms'
export { default as poolsConfig } from './pools'
export { default as multiPoolConfig } from './multiPool'
export { default as vaultsConfig } from './vaults'
export { default as seriesesConfig } from './serieses'
